import { ServerOverviewToggle } from '../../../components/server-overview-toggle/server-overview-toggle'
import { createNgReactBridgeDirective } from '../../react-bridge'

export const reactServerOverviewToggle = createNgReactBridgeDirective(
  'reactServerOverviewToggle',

  [],

  ServerOverviewToggle,

  [
    'checked',
    'disabled',
    'onChange',
    'language',
    'reference',
    'product',
    'blocked',
    'propertyName',
    'propertyLocation',
    'agentVersion'
  ]
)
